import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('message-icon', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 49 48"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.438 6)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0c11.046 0 20 7.96 20 17.778 0 9.818-8.954 17.778-20 17.778-3.265 0-6.347-.696-9.07-1.93l-8.082.525a1.6 1.6 0 0 1-1.545-2.291l2.04-4.238C1.232 24.803 0 21.418 0 17.778 0 7.959 8.954 0 20 0z",
    stroke: props.colors[0],
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), /*#__PURE__*/React.createElement("circle", {
    fill: props.colors[0],
    cx: "10.937",
    cy: "18.25",
    r: "2.25"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: props.colors[0],
    cx: "20.432",
    cy: "18.25",
    r: "2.25"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: props.colors[0],
    cx: "29.927",
    cy: "18.25",
    r: "2.25"
  })));
});